(() => {
  function init(source) {
    if (source.dataset.galleryReady) return true;
    const section = source.closest('.shopify-section');
    const slider = section?.querySelector('media-gallery [id^="SliderGallery-"]');
    const original = source.querySelector('button.at-button');
    if (!slider || !original) return false;
    const eligible = new Set(source.dataset.aiMultipleDesigns === 'true'
      ? source.dataset.aiVariantMedia.split(',').filter(Boolean)
      : [source.dataset.aiFirstMedia]);
    const media = [...slider.querySelectorAll('[data-media-id][data-media-type="image"]')]
      .filter(item => eligible.has(item.dataset.mediaId));
    media.forEach(anchor => {
    if (anchor.querySelector('.mfos-ai-gallery-button')) return;
    anchor.classList.add('mfos-ai-photo-anchor');
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'mfos-ai-gallery-button';
    button.setAttribute('aria-haspopup', 'dialog');
    button.innerHTML = '<svg class="mfos-ai-pillow-outline" viewBox="0 0 140 52" preserveAspectRatio="none" aria-hidden="true"><path d="M5 4 Q70 12 135 4 Q127 26 135 48 Q70 40 5 48 Q13 26 5 4Z"/></svg><span class="mfos-ai-gallery-content"></span>';
    const content = button.querySelector('.mfos-ai-gallery-content');
    const icon = original.querySelector('[data-el="button-icon"] svg');
    if (icon) { const copy = icon.cloneNode(true); copy.setAttribute('aria-hidden', 'true'); content.append(copy); }
    const label = document.createElement('span');
    label.textContent = original.querySelector('[data-el="button-text"]')?.textContent.trim() || 'Пробвай с AI';
    content.append(label);
    button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      source.querySelector('button.at-button')?.click();
    });
    anchor.append(button);
    });
    source.classList.add('mfos-ai-source-ready');
    source.dataset.galleryReady = 'true';
    return true;
  }
  function boot() {
    document.querySelectorAll('[data-mfos-ai-source]').forEach(source => {
      if (init(source)) return;
      const observer = new MutationObserver(() => { if (init(source)) observer.disconnect(); });
      observer.observe(source, {childList: true, subtree: true});
      setTimeout(() => observer.disconnect(), 30000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true});
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
